
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/komorkowy",
      function () {
        return require("private-next-pages/komorkowy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/komorkowy"])
      });
    }
  